module.exports = __webpack_public_path__ + "static/img/FLORENTINE-OAK.5ef3d64.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/FLORENTINE-OAK.png
// module id = QDfM
// module chunks = 0